import { Root, Indicator } from "@radix-ui/react-checkbox";
import { CheckIcon } from "@radix-ui/react-icons";
import { forwardRef } from "react";

interface CheckBoxProps {
  id: string;
  children: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const CheckBox = forwardRef<HTMLButtonElement, CheckBoxProps>(
  ({ id, children, checked, onChange }, ref) => {
    return (
      <div>
        <div className="flex items-center space-x-3">
          <Root
            className="relative flex-shrink-0 w-5 h-5 rounded-[4px] border border-theme-border-strong bg-theme-bg-surface flex items-center justify-center
                     data-[state=checked]:border-transparent data-[state=checked]:bg-checkbox-gradient
                     focus:outline-none focus:ring-2 focus:ring-primary-350 focus:ring-offset-1 focus:ring-offset-theme-bg-surface"
            checked={checked}
            onCheckedChange={onChange}
            id={id}
            ref={ref}
          >
            <Indicator>
              <CheckIcon className="text-white w-[14px] h-[14px]" />
            </Indicator>
          </Root>
          <label
            className="text-14 text-theme-text-secondary cursor-pointer select-none leading-snug"
            htmlFor={id}
          >
            {children}
          </label>
        </div>
      </div>
    );
  },
);
